// WeeklyCalendar.jsx - Sadece mevcut haftayı gösteren takvim
import React, { useState, useEffect } from 'react';
import { getMonday } from '../../utils/newApi';

const WeeklyCalendar = ({ selectedDate, onSelectDate }) => {
  const [currentWeek, setCurrentWeek] = useState([]);

  useEffect(() => {
    generateCurrentWeek();
  }, []);

  const generateCurrentWeek = () => {
    const monday = getMonday();
    const week = [];
    
    for (let i = 0; i < 7; i++) {
      const date = new Date(monday);
      date.setDate(monday.getDate() + i);
      week.push(date);
    }
    
    setCurrentWeek(week);
  };

  const dayNames = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const isToday = (date) => {
    return isSameDay(date, new Date());
  };

  const isPast = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-blue-100">
          Tarih Seçimi
        </h3>
        <div className="text-sm text-gray-200">
          Bu Hafta (Pazartesi - Pazar)
        </div>
      </div>

      {/* Hafta Grid */}
      <div className="grid grid-cols-7 gap-2">
        {currentWeek.map((date, index) => {
          const isSelected = isSameDay(date, selectedDate);
          const isTodayDate = isToday(date);
          const isPastDate = isPast(date);

          return (
            <div
              key={index}
              onClick={() => !isPastDate && onSelectDate(date)}
              className={`
                relative p-3 rounded-lg text-center cursor-pointer transition-all duration-200
                ${isSelected
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/50 scale-105'
                  : isPastDate
                  ? 'bg-gray-800/30 text-gray-600 cursor-not-allowed'
                  : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 hover:scale-105'
                }
                ${isTodayDate && !isSelected ? 'border-2 border-blue-400' : ''}
              `}
            >
              {/* Gün İsmi */}
              <div className="text-xs font-semibold mb-1">
                {dayNames[index]}
              </div>

              {/* Gün Numarası */}
              <div className="text-2xl font-bold">
                {date.getDate()}
              </div>

              {/* Ay */}
              <div className="text-xs mt-1 opacity-75">
                {date.toLocaleDateString('tr-TR', { month: 'short' })}
              </div>

              {/* Bugün İşareti */}
              {isTodayDate && (
                <div className="absolute top-1 right-1">
                  <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                </div>
              )}

              {/* Geçmiş Tarih İşareti */}
              {isPastDate && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Seçili Tarih Bilgisi */}
      {selectedDate && (
        <div className="p-4 bg-blue-900/20 border border-blue-700 rounded-lg">
          <p className="text-sm text-blue-200">
            <strong>Seçili Tarih:</strong>{' '}
            {selectedDate.toLocaleDateString('tr-TR', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </p>
        </div>
      )}

      {/* Bilgilendirme */}
      <div className="text-xs text-gray-300 space-y-1">
        <p>• Sadece mevcut hafta için rezervasyon yapılabilir</p>
        <p>• Geçmiş tarihler için rezervasyon yapılamaz</p>
        <p>• Her Pazartesi yeni hafta açılır</p>
      </div>
    </div>
  );
};

export default WeeklyCalendar;
